import React, {useContext, useEffect} from "react"
import {RouteStageContext} from "../stageStatus/context/RouteStageContext";
import {StageFilterContext} from "../stageStatus/context/StageFilterContext";
import {getRefreshInterval} from "../util/Util";
import {AR_V2, CART_VIEW, DEFAULT_CAPABILITIES} from "../util/Constants";
import RouteViewTable from "./RouteViewTable";
import CartViewTable from "./CartViewTable";
import {getRemainingTTL, isRouteCacheValid} from "../util/CacheManager";
import {ROUTE_DATA_CACHE_KEY} from "../util/LocalStorageKeys";
import useCapabilityContext from "../global/context/useCapabilityContext";

const RouteStageTable = (props) => {

    const {dispatch} = useContext(RouteStageContext)
    const {viewModelF, dispatchF} = useContext(StageFilterContext)
    const {configViewModel, configDispatch, configViewModelRef} = useCapabilityContext()

    const getRouteData = () => {
        const config = configViewModelRef.current;
        if (config.capability === AR_V2 || (config.stationConfig.initialised && Array.isArray(viewModelF.xptNodes))) {
            dispatch({
                type: 'LOAD_VIEW',
                data: {
                    dispatcher: dispatch,
                    filterDispatcher: dispatchF,
                    baseUrl: config.baseUrl,
                    capability: config.capability,
                    xptNodes: viewModelF.xptNodes,
                    stationConfig: config.stationConfig,
                    configDispatch: configDispatch
                }
            });
        }
    }

    /**
     * This gets invoked on following events:
     *  1. On every page load,
     *  2. Every time xpt filter value is changed,
     *  3. When station config's initialised attribute changes - usually happens when NodeConfig API response is received.
     *  Note: Updates on station config does not re-render useEffect, if initialised attribute value is not changed.
     */
    useEffect(() => {
        getRouteData();
        let firstPollTime = getRefreshInterval(configViewModelRef.current.stationConfig);
        if (DEFAULT_CAPABILITIES.includes(configViewModelRef.current.capability)) {
            const remainingTTL = getRemainingTTL(ROUTE_DATA_CACHE_KEY);
            if (viewModelF.xptNodes && isRouteCacheValid(viewModelF.xptNodes)) {
                firstPollTime = remainingTTL;
            }
        }

        const timeoutHandler = () => {
            getRouteData();
            timeout = setTimeout(timeoutHandler, getRefreshInterval(configViewModelRef.current.stationConfig));
        }
        let timeout = setTimeout(timeoutHandler, firstPollTime);

        return () => clearTimeout(timeout);
    }, [viewModelF.xptNodes, configViewModel.stationConfig.initialised]);

    return (
    <div>
            <div> {viewModelF.viewType === CART_VIEW
            && (!DEFAULT_CAPABILITIES.includes(configViewModel.capability) || configViewModel.stationConfig.pickStageDecoupleEnabled) ?
                <CartViewTable history={props.history}/>
                :
                <RouteViewTable history={props.history}/>
            }
            </div>
    </div>
    )
}

export default RouteStageTable


// WEBPACK FOOTER //
// ./src/components/routeStageStatus/RouteStageTable.js